import { PageHero } from "../components/PageHero";
import { Eyebrow } from "../components/Reveal";

const mail = (m) => <a href={`mailto:${m}`} className="underline underline-offset-4">{m}</a>;

const SECTIONS = [
  ["editeur", "Éditeur du site", [
    ["Raison sociale", "ENOVA SARL"],
    ["Capital social", "100 000 XPF"],
    ["RIDET", "955807.001"],
    ["Siège social", "30 route de la Baie des Dames, Ducos le Centre, BP 27838, 98863 Nouméa Cedex"],
    ["Téléphone", <a href="tel:+687297000" className="underline underline-offset-4">+687 29 70 00</a>],
    ["E-mail", mail("contact@enova.nc")],
  ]],
  ["publication", "Directeur de la publication", [
    ["Nom", "Jean-Marie Ricciarelli, co-gérant"],
    ["Contact", mail("jeanmarie@enova.nc")],
  ]],
  ["hebergeur", "Hébergeur", [
    ["Société", "AGIONE TECHNOLOGIES PRIVATE LIMITED"],
    ["Contact", "support@emergent.sh"],
  ]],
  ["donnees", "Données personnelles", [
    ["Responsable du traitement", "ENOVA SARL"],
    ["Finalité", "Les données saisies dans les formulaires du site (devis, assistance, contact) servent uniquement au traitement de la demande formulée."],
    ["Durée de conservation", "Le temps du traitement de la demande uniquement. Aucune conservation ultérieure."],
    ["Vos droits", <>Pour exercer vos droits d'accès et de suppression : {mail("dpo@enova.nc")}</>],
  ]],
  ["propriete", "Propriété intellectuelle", [
    ["Contenus", "L'ensemble des logos et des textes présents sur ce site appartiennent exclusivement à ENOVA SARL. Toute reproduction sans autorisation est interdite."],
  ]],
];

export default function MentionsLegales() {
  return (
    <div data-testid="legal-page">
      <PageHero eyebrow="Informations légales" title="Mentions légales." lead="Les informations relatives à l'éditeur, à l'hébergement et au traitement de vos données." />
      <section className="mx-auto max-w-4xl px-5 lg:px-8 py-16 lg:py-24 space-y-14">
        {SECTIONS.map(([id, title, rows]) => (
          <div key={id} data-testid={`legal-section-${id}`}>
            <Eyebrow>{title}</Eyebrow>
            <dl className="mt-6 border-t border-ink/10">
              {rows.map(([k, v]) => (
                <div key={k} className="grid sm:grid-cols-3 gap-1 sm:gap-6 py-4 border-b border-ink/10">
                  <dt className="text-sm text-ink/55">{k}</dt>
                  <dd className="sm:col-span-2">{v}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </section>
    </div>
  );
}
